import _slicedToArray from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      &:hover .checkbox-icon::before {\n        border-color: ", ";\n      }\n      &:hover input:checked ~ .checkbox-icon::before {\n        background-color: ", ";\n        border-color: ", ";\n      }\n\n      input:focus-visible ~ .checkbox-icon:before {\n        box-shadow: 0 0 0 2px ", ";\n      }\n      input:checked:focus-visible ~ .checkbox-icon::before {\n        box-shadow: 0 0 0 2px ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  display: flex;\n  align-items: flex-start;\n  user-select: none;\n  color: ", ";\n\n  input[type='checkbox'] {\n    opacity: 0;\n    outline: none;\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    z-index: -1;\n    background-color: transparent;\n  }\n\n  .checkbox-icon {\n    display: flex;\n    align-items: center;\n    margin-right: 0.5rem;\n  }\n\n  .checkbox-icon:before {\n    content: '';\n    width: 1.25rem;\n    height: 1.25rem;\n    border-radius: 0.25rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 2px solid ", ";\n    transition: 0.1s ease;\n  }\n\n  .checkbox-icon:after {\n    content: '';\n    opacity: 0;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' width='24'%3E%3Cpath d='M0 0h24v24H0z' fill='none' /%3E%3Cpath fill='%23ffffff' d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'/%3E%3C/svg%3E\");\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 1.25rem;\n    height: 1.25rem;\n    border-radius: 0.25rem;\n    position: absolute;\n    border: 2px solid transparent;\n  }\n\n  .checkbox-label {\n    margin-top: 2px;\n    white-space: nowrap;\n  }\n\n  input:checked ~ .checkbox-icon::before {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n\n  input:checked ~ .checkbox-icon::after {\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useState, useEffect, useCallback } from 'react';
import styled, { css } from 'styled-components';
var StyledCheckbox = styled.label(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.disabled ? props.theme.colors.disabledText : props.theme.colors.label;
}, function (props) {
  return props.disabled ? props.theme.colors.disabled : props.theme.colors.border;
}, function (props) {
  return props.disabled ? props.theme.colors.disabled : props.theme.colors.primary;
}, function (props) {
  return props.disabled ? props.theme.colors.disabled : props.theme.colors.primary;
}, function (props) {
  return !props.disabled && css(_templateObject2(), function (props) {
    return props.theme.colors.inputBorder;
  }, function (props) {
    return props.theme.colors.primaryHover;
  }, function (props) {
    return props.theme.colors.primaryHover;
  }, function (props) {
    return props.theme.colors.inputBorder;
  }, function (props) {
    return props.theme.colors.primaryHover;
  });
});
var Checkbox = forwardRef(function (_a, ref) {
  var _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      checked = _a.checked,
      defaultChecked = _a.defaultChecked,
      children = _a.children,
      onChange = _a.onChange,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      rest = __rest(_a, ["disabled", "checked", "defaultChecked", "children", "onChange", "className"]);

  var _useState = useState(function () {
    return defaultChecked || false;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      selfChecked = _useState2[0],
      setSelfChecked = _useState2[1];

  var changeHandle = useCallback(function (ev) {
    if (disabled) {
      return;
    }

    setSelfChecked(!selfChecked);

    if (onChange) {
      var event = Object.assign(Object.assign({}, ev), {
        target: Object.assign(Object.assign({}, ev.target), {
          checked: !selfChecked
        })
      });
      onChange(event);
    }
  }, [onChange, disabled, selfChecked]);
  useEffect(function () {
    if (checked === undefined) {
      return;
    }

    setSelfChecked(Boolean(checked));
  }, [checked]);
  var checkboxRef = useRef(null);
  useImperativeHandle(ref, function () {
    return checkboxRef.current;
  });
  return _jsxs(StyledCheckbox, Object.assign({
    className: "checkbox-container ".concat(className),
    disabled: disabled,
    checked: selfChecked
  }, {
    children: [_jsx("input", Object.assign({
      type: "checkbox",
      ref: checkboxRef,
      onChange: changeHandle,
      checked: selfChecked,
      disabled: disabled
    }, rest), void 0), _jsx("span", {
      className: "checkbox-icon"
    }, void 0), children && _jsx("span", Object.assign({
      className: "checkbox-label"
    }, {
      children: children
    }), void 0)]
  }), void 0);
});
export default Checkbox;